// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SYhQ","inner":"styles_inner__2Zox2","right":"styles_right__1rSiR","close":"styles_close__qDEJ2","footer":"styles_footer__2xibJ"};